"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonLink = exports.StyledButton = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme/Theme.variables");

var _Theme2 = require("../../Theme/Theme.spacing");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  /* Spacing */\n  ", ";\n  ", ";\n"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  /* Spacing */\n  ", ";\n  ", ";\n"]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n    padding: 24px 48px;\n    font-size: 20px;\n    line-height: 1.33333;\n    border-radius: 0;\n  "]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n    padding: 8px 16px;\n    font-size: 11.2px;\n    line-height: 1.5;\n    border-radius: 0;\n    letter-spacing: 0.04em;\n  "]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n    padding: 4px 8px;\n    font-size: 11.2px;\n    line-height: 1.5;\n    border-radius: 0;\n    letter-spacing: 0.04em;\n  "]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: none;\n    background-color: transparent;\n    color: ", ";\n  "]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: none;\n    background-color: transparent;\n    color: ", ";\n    &:hover,\n    &:focus {\n      background-color: ", ";\n    }\n    @media (hover: hover) {\n      &:hover,\n      &:focus {\n        color: ", ";\n        background-color: transparent;\n        .button-icon-hover {\n          opacity: 1;\n        }\n      }\n    }\n    &:active {\n      background-color: ", ";\n    }\n  "]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n          background-color: ", ";\n        "]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    &:hover,\n    &:focus {\n      ", ";\n    }\n  "]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      ", ";\n    }\n\n    &:after {\n      background-color: ", ";\n    }\n  "]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n          background-color: ", ";\n        "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    &:hover,\n    &:focus {\n      ", ";\n    }\n  "]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      ", ";\n    }\n\n    &:after {\n      background-color: ", ";\n    }\n  "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n          background-color: ", ";\n        "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    &:hover,\n    &:focus {\n      ", ";\n    }\n  "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      ", ";\n    }\n  "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n          background-color: ", ";\n        "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n    &:hover,\n    &:focus {\n      ", ";\n    }\n  "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      ", ";\n    }\n\n    &:after {\n      background-color: ", ";\n    }\n  "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n  "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n        &:hover,\n        &:focus {\n          background-color: ", ";\n          .button-icon-hover {\n            opacity: 1;\n          }\n        }\n        &:active {\n          background-color: ", " !important;\n        }\n      "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n        cursor: not-allowed;\n      "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    white-space: nowrap;\n    text-decoration: none;\n    cursor: pointer;\n    position: relative;\n    backface-visibility: hidden;\n    border: 2px solid transparent;\n    padding: 16px 32px;\n    font-size: 13px;\n    font-weight: 700;\n    font-family: ", ";\n    line-height: 1;\n    letter-spacing: 0.65px;\n    background-color: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.15s cubic-bezier(0, 0.5, 1, 1);\n    ", "\n    color: ", ";\n\n    ", ";\n\n    ", ";\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 1.33333;\n    border-radius: 0;\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n    padding: 8px 16px;\n    font-size: 10.24px;\n    line-height: 1.5;\n    border-radius: 0;\n    letter-spacing: 0.1em;\n  "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n    padding: 4px 8px;\n    font-size: 10.24px;\n    line-height: 1.5;\n    border-radius: 0;\n    letter-spacing: 0.1em;\n  "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: none;\n    background-color: transparent;\n    color: ", ";\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n        &:hover {\n          box-shadow: ", ";\n        }\n        @media (hover: hover) {\n          &:hover {\n            box-shadow: none;\n            color: ", ";\n            .button-icon-hover {\n              opacity: 1;\n            }\n          }\n        }\n        &:focus {\n          color: black;\n          .button-icon-hover {\n            opacity: 1;\n          }\n        }\n        &:active {\n          background-color: ", ";\n          color: black;\n          .button-icon-hover {\n            opacity: 1;\n          }\n        }\n      "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: none;\n    background-color: transparent;\n    color: ", ";\n    ", "\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        border-bottom-color: ", ";\n\n        &:hover {\n          box-shadow: ", ";\n        }\n        @media (hover: hover) {\n          &:hover {\n            color: black;\n            box-shadow: ", ";\n            background-color: ", ";\n            border-left-color: transparent;\n            border-top-color: transparent;\n            border-right-color: transparent;\n            text-decoration: none;\n            .button-icon-hover {\n              opacity: 1;\n            }\n          }\n        }\n        &:focus {\n          color: black;\n          box-shadow: ", ";\n          background-color: ", ";\n          border-left-color: transparent;\n          border-top-color: transparent;\n          border-right-color: transparent;\n          text-decoration: none;\n          .button-icon-hover {\n            opacity: 1;\n          }\n        }\n        &:active {\n          box-shadow: none;\n          background-color: ", ";\n          color: black;\n          .button-icon-hover {\n            opacity: 1;\n          }\n        }\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        cursor: not-allowed;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12.8px;\n    font-weight: 600;\n    font-family: ", ";\n    text-decoration: none;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    white-space: nowrap;\n    line-height: 1;\n    backface-visibility: hidden;\n    cursor: pointer;\n    position: relative;\n    padding: 16px 32px;\n    border: 1px solid transparent;\n    border-radius: 0;\n    transition: all 0.15s cubic-bezier(0, 0.5, 1, 1);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n    background-color: ", ";\n    color: ", ";\n\n    ", ";\n\n    ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      opacity: 0.3;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      display: block;\n      min-width: 100%;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  text-align: center;\n  /* full width buttons */\n  ", "\n\n  /* disabled */\n  ", "\n\n  /* Menguin */\n  ", "\n  ", "\n  ", "\n\n  /* Gentux */\n  ", "\n  ", "\n  ", "\n\n  ", "\n\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // main style entrypoint


var buttonStyle = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.block && (0, _styledComponents.css)(_templateObject2());
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.theme.brand === 'menguin' && buttonMenguin['default'];
}, function (props) {
  return props.theme.brand === 'menguin' && buttonMenguin["".concat(props.buttonType).concat(props.outline ? '_outline' : '')];
}, function (props) {
  return props.theme.brand === 'menguin' && props.size && buttonMenguin[props.size];
}, function (props) {
  return props.theme.brand === 'gentux' && buttonGentux['default'];
}, function (props) {
  return props.theme.brand === 'gentux' && buttonGentux["".concat(props.buttonType).concat(props.outline ? '_outline' : '')];
}, function (props) {
  return props.theme.brand === 'gentux' && props.size && buttonGentux[props.size];
}, function (props) {
  return props.buttonIcon && "\n      .button-icon-wrap {\n        display: inline-block;\n        position: relative;\n      }\n      .button-icon-base,\n      .button-icon-hover {\n        display:block;\n      }\n      .button-icon-hover {\n        opacity: 0;\n        position: absolute;\n        left: 0;\n        top: 0;\n        transition: all 0.15s cubic-bezier(0, 0.5, 1, 1);\n      }\n    ";
}); // brand specific buttons

var buttonGentux = {
  default: (0, _styledComponents.css)(_templateObject4(), function (props) {
    return (0, _Theme.variables)(props).fontButton;
  }, function (props) {
    return props.buttonIconPosition === 'right' && 'flex-flow:row-reverse;';
  }, function (props) {
    return (0, _Theme.variables)(props).gray;
  }, function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return props.disabled && (0, _styledComponents.css)(_templateObject5());
  }, function (props) {
    return !props.disabled && props.buttonType !== 'link' && (0, _styledComponents.css)(_templateObject6(), function (props) {
      return (0, _Theme.variables)(props).gray;
    }, function (props) {
      return (0, _Theme.variables)(props).shadows[2];
    }, function (props) {
      return (0, _Theme.variables)(props).shadows[3];
    }, function (props) {
      return (0, _Theme.variables)(props).white;
    }, function (props) {
      return (0, _Theme.variables)(props).shadows[3];
    }, function (props) {
      return (0, _Theme.variables)(props).white;
    }, function (props) {
      return (0, _Theme.variables)(props).grayLight;
    });
  }),
  default_outline: (0, _styledComponents.css)(_templateObject7(), function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return (0, _Theme.variables)(props).gray;
  }),
  primary: (0, _styledComponents.css)(_templateObject8(), function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }),
  primary_outline: (0, _styledComponents.css)(_templateObject9(), function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return (0, _Theme.variables)(props).black;
  }),
  info: (0, _styledComponents.css)(_templateObject10(), function (props) {
    return (0, _Theme.variables)(props).primary;
  }, function (props) {
    return (0, _Theme.variables)(props).primary;
  }, function (props) {
    return (0, _Theme.variables)(props).black;
  }),
  info_outline: (0, _styledComponents.css)(_templateObject11(), function (props) {
    return (0, _Theme.variables)(props).textPrimary;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return (0, _Theme.variables)(props).primary;
  }),
  danger: (0, _styledComponents.css)(_templateObject12(), function (props) {
    return (0, _Theme.variables)(props).danger;
  }, function (props) {
    return (0, _Theme.variables)(props).danger;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }),
  danger_outline: (0, _styledComponents.css)(_templateObject13(), function (props) {
    return (0, _Theme.variables)(props).danger;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return (0, _Theme.variables)(props).danger;
  }),
  success: (0, _styledComponents.css)(_templateObject14(), function (props) {
    return (0, _Theme.variables)(props).green;
  }, function (props) {
    return (0, _Theme.variables)(props).green;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }),
  success_outline: (0, _styledComponents.css)(_templateObject15(), function (props) {
    return (0, _Theme.variables)(props).green;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return (0, _Theme.variables)(props).green;
  }),
  link: (0, _styledComponents.css)(_templateObject16(), function (props) {
    return (0, _Theme.variables)(props).textPrimary;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject17(), function (props) {
      return (0, _Theme.variables)(props).shadows[3];
    }, function (props) {
      return (0, _Theme.variables)(props).black;
    }, function (props) {
      return (0, _Theme.variables)(props).grayLight;
    });
  }),
  link_outline: (0, _styledComponents.css)(_templateObject18(), function (props) {
    return (0, _Theme.variables)(props).textPrimary;
  }),
  xs: (0, _styledComponents.css)(_templateObject19()),
  sm: (0, _styledComponents.css)(_templateObject20()),
  lg: (0, _styledComponents.css)(_templateObject21())
};
var buttonMenguin = {
  default: (0, _styledComponents.css)(_templateObject22(), function (props) {
    return (0, _Theme.variables)(props).fontButton;
  }, function (props) {
    return (0, _Theme.variables)(props).grayDefaultButton;
  }, function (props) {
    return props.buttonIconPosition === 'right' && 'flex-flow:row-reverse;';
  }, function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return props.disabled && (0, _styledComponents.css)(_templateObject23());
  }, function (props) {
    return !props.disabled && props.buttonType !== 'link' && (0, _styledComponents.css)(_templateObject24(), function (props) {
      return (0, _Theme.variables)(props).gray;
    }, function (props) {
      return (0, _Theme.variables)(props).grayDark;
    });
  }),
  default_outline: (0, _styledComponents.css)(_templateObject25(), function (props) {
    return (0, _Theme.variables)(props).gray;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }),
  primary: (0, _styledComponents.css)(_templateObject26(), function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject27(), function (props) {
      return (0, _Theme.variables)(props).blackHover;
    });
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }),
  primary_outline: (0, _styledComponents.css)(_templateObject28(), function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject29(), function (props) {
      return (0, _Theme.variables)(props).white;
    }, function (props) {
      return (0, _Theme.variables)(props).black;
    });
  }),
  info: (0, _styledComponents.css)(_templateObject30(), function (props) {
    return (0, _Theme.variables)(props).primary;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject31(), function (props) {
      return (0, _Theme.variables)(props).primaryHover;
    });
  }),
  info_outline: (0, _styledComponents.css)(_templateObject32(), function (props) {
    return (0, _Theme.variables)(props).primary;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return (0, _Theme.variables)(props).primary;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject33(), function (props) {
      return (0, _Theme.variables)(props).white;
    }, function (props) {
      return (0, _Theme.variables)(props).primary;
    });
  }),
  danger: (0, _styledComponents.css)(_templateObject34(), function (props) {
    return (0, _Theme.variables)(props).danger;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject35(), function (props) {
      return (0, _Theme.variables)(props).dangerHover;
    });
  }, function (props) {
    return (0, _Theme.variables)(props).danger;
  }),
  danger_outline: (0, _styledComponents.css)(_templateObject36(), function (props) {
    return (0, _Theme.variables)(props).danger;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return (0, _Theme.variables)(props).danger;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject37(), function (props) {
      return (0, _Theme.variables)(props).white;
    }, function (props) {
      return (0, _Theme.variables)(props).danger;
    });
  }),
  success: (0, _styledComponents.css)(_templateObject38(), function (props) {
    return (0, _Theme.variables)(props).green;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject39(), function (props) {
      return (0, _Theme.variables)(props).greenHover;
    });
  }, function (props) {
    return (0, _Theme.variables)(props).green;
  }),
  success_outline: (0, _styledComponents.css)(_templateObject40(), function (props) {
    return (0, _Theme.variables)(props).green;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }, function (props) {
    return (0, _Theme.variables)(props).green;
  }, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject41(), function (props) {
      return (0, _Theme.variables)(props).white;
    }, function (props) {
      return (0, _Theme.variables)(props).green;
    });
  }),
  link: (0, _styledComponents.css)(_templateObject42(), function (props) {
    return (0, _Theme.variables)(props).textPrimary;
  }, function (props) {
    return (0, _Theme.variables)(props).grayLighter;
  }, function (props) {
    return (0, _Theme.variables)(props).black;
  }, function (props) {
    return (0, _Theme.variables)(props).grayLight;
  }),
  link_outline: (0, _styledComponents.css)(_templateObject43(), function (props) {
    return (0, _Theme.variables)(props).textPrimary;
  }),
  xs: (0, _styledComponents.css)(_templateObject44()),
  sm: (0, _styledComponents.css)(_templateObject45()),
  lg: (0, _styledComponents.css)(_templateObject46())
}; // Button Components

var StyledButton = _styledComponents.default.button(_templateObject47(), buttonStyle, function (props) {
  return (0, _Theme2.spacing)(props);
}, _styledSystem.space);

exports.StyledButton = StyledButton;

var StyledButtonLink = _styledComponents.default.a(_templateObject48(), buttonStyle, function (props) {
  return (0, _Theme2.spacing)(props);
}, _styledSystem.space);

exports.StyledButtonLink = StyledButtonLink;